// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/player." + (chunkId === 992 ? "tailwindcss" : chunkId) + "." + {"166":"ec11d5d5","992":"b67572ec"}[chunkId] + ".css";
};